import { Fragment } from "react";
import type { OfferItem } from "../../types";
import type { VipStatus } from "../../types/api";
import CountdownTimer from "../CountdownTimer";
import ShopItemView, { type CardVariant } from "../ShopItemView/ShopItemView";
import styles from "./styles.module.css";

type Props = {
  items: OfferItem[];
  getVariant: (item: OfferItem) => CardVariant;
  vipStatus: VipStatus | null;
  onChooseClick: (item: OfferItem) => void;
};

export default function OfferGroupView({ items, getVariant, vipStatus, onChooseClick }: Props) {
  const expirationDate = Math.min(...items.map((i) => i.expirationDate));

  return (
    <section className={styles.group} aria-label="Выберите один вариант">
      <div className={styles.header}>
        <div className={styles.title}>Выбери один вариант</div>
        <div className={styles.timer}>
          <CountdownTimer targetEpochSeconds={expirationDate} />
        </div>
      </div>
      <div className={styles.hint}>Купить можно только один — остальные варианты исчезнут после покупки</div>

      <div className={styles.items}>
        {items.map((item, index) => (
          <Fragment key={item.id}>
            {index > 0 && (
              <div className={styles.orDivider} aria-hidden="true">
                <div className={styles.orLine} />
                <span className={styles.orChip}>или</span>
                <div className={styles.orLine} />
              </div>
            )}
            <ShopItemView
              product={item}
              variant={getVariant(item)}
              vipStatus={vipStatus}
              hideLabel
              onChooseClick={() => onChooseClick(item)}
            />
          </Fragment>
        ))}
      </div>
    </section>
  );
}
